import { FC, ReactElement } from 'react'

import './TrackLogItem.scss'

interface TrackLogItemProps {
    title: string
    text: string
}

export const TrackLogItem: FC<TrackLogItemProps> = ({ title, text }): ReactElement => (
    <li className="track-log-item">
        <div className="track-log-item__title">
            { title }
        </div>
        <div className="track-log-item__text">
            { text }
        </div>
    </li>
)
